import React from 'react'

import style from './style'

const SubmitEmailBox = ({ backgroundColor }) => (
  <div className="submit-email-preview-box">
    <span>Email Address</span>
    <div className="input">
      <div
        className="submit-button"
        style={{
          backgroundColor
        }}>
        Submit
      </div>
    </div>
  </div>
)

export default SubmitEmailBox



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/EmailCapturePreview/components/SubmitEmailPreviewBox/index.js